module.exports.app_id = "PMA";

module.exports.api_url = "https://pma-api.polymedia.nl";
module.exports.api_token = "zj8f8sntaUJ2vvq3";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://192.168.0.10:3001";
	module.exports.api_token = "123";
}



// WEBPACK FOOTER //
// ./src/config.js